import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

export type BreadcrumbItem = { key: string; path?: string }

type Props = { items: BreadcrumbItem[] }

export default function Breadcrumbs({ items }: Props) {
  const { t } = useTranslation()

  return (
    <nav aria-label={t('a11y.breadcrumbsLabel', { defaultValue: 'Breadcrumbs' })} className="pt-24 pb-4">
      <ol className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-wrap items-center gap-2 text-sm text-slate-500 dark:text-slate-400">
        <li>
          <Link to="/" className="hover:text-primary transition-colors">
            {t('breadcrumbs.home')}
          </Link>
        </li>
        {items.map((item) => (
          <li key={item.key} className="flex items-center gap-2">
            <span className="text-slate-300 dark:text-slate-600" aria-hidden>/</span>
            {item.path ? (
              <Link to={item.path} className="hover:text-primary transition-colors">
                {t(`breadcrumbs.${item.key}`)}
              </Link>
            ) : (
              <span className="text-slate-700 dark:text-slate-300 font-medium">
                {t(`breadcrumbs.${item.key}`)}
              </span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  )
}
